import All from './all.vue'
import Highlight from './highlight.vue'
import Person from './person.vue'
import Opus from './opus.vue'
import Case from './case.vue'
import Sense from './sense.vue'
import Class from './class.vue'
import Help from './help.vue'
import School from './school.vue'
import { SITE_SEARCH_TYPE } from '~/constants'

const Page = {
  [SITE_SEARCH_TYPE.ALL]: All,
  [SITE_SEARCH_TYPE.HIGHLIGHT]: Highlight,
  [SITE_SEARCH_TYPE.PERSON]: Person,
  [SITE_SEARCH_TYPE.OPUS]: Opus,
  [SITE_SEARCH_TYPE.SENSE]: Sense,
  [SITE_SEARCH_TYPE.CASE]: Case,
  [SITE_SEARCH_TYPE.CLASS]: Class,
  [SITE_SEARCH_TYPE.HELP]: Help,
  [SITE_SEARCH_TYPE.SCHOOL]: School,
}

export default Page
